import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { PaymentInfo } from './PaymentInfo';
import { ShieldCheck, Clock } from 'lucide-react';
export function Offer() {
  return <section id="offer" className="py-24 bg-dark-900 relative overflow-hidden" data-id="element-83">
      {/* Glow background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-neon-cyan/10 rounded-full blur-[100px] pointer-events-none" data-id="element-84"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-85">
        <div className="max-w-3xl mx-auto bg-dark-800 border border-dark-700 rounded-3xl p-8 md:p-16 text-center shadow-2xl relative" data-id="element-86">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} data-id="element-87">
            <h2 className="text-3xl md:text-5xl font-oswald font-bold text-white mb-6" data-id="element-88">
              NO COMPRÁS UN PDF.
              <br data-id="element-89" />
              <span className="text-neon-cyan text-shadow-neon" data-id="element-90">
                COMPRÁS UN SISTEMA QUE ELIMINA TU LIMITACIÓN.
              </span>
            </h2>

            <p className="text-xl text-gray-300 font-inter mb-10" data-id="element-91">
              Sistema Grip Dominante + 4 Bonos Exclusivos
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10 text-sm font-inter text-gray-400" data-id="element-92">
              <div className="flex items-center gap-2" data-id="element-93">
                <ShieldCheck className="w-5 h-5 text-neon-cyan" data-id="element-94" />
                <span data-id="element-95">Pago 100% Seguro</span>
              </div>
              <div className="hidden sm:block text-dark-700" data-id="element-96">•</div>
              <div className="flex items-center gap-2" data-id="element-97">
                <Clock className="w-5 h-5 text-neon-cyan" data-id="element-98" />
                <span data-id="element-99">Acceso Inmediato</span>
              </div>
            </div>

            <Button size="xl" fullWidth className="md:w-auto md:px-16 py-6 text-2xl" data-id="element-100">
              ACCEDER AHORA
            </Button>

            <p className="mt-6 text-neon-cyan font-bold animate-pulse" data-id="element-101">
              Disponible ahora. Descarga instantánea.
            </p>
            <PaymentInfo data-id="element-102" />
          </motion.div>
        </div>
      </div>
    </section>;
}